import { render, staticRenderFns } from "./CmgRewardCard.vue?vue&type=template&id=548ae110&scoped=true&lang=pug&"
import script from "./cmg-reward-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-reward-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardCard.vue?vue&type=style&index=0&id=548ae110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ae110",
  null
  
)

export default component.exports